module.exports = __webpack_public_path__ + "static/teleco_5-00c6427338bf89bf68a88a87f0787260.jpg";